import { render, staticRenderFns } from "./IntAstaSxPreview.vue?vue&type=template&id=a415ad26"
import script from "./IntAstaSxPreview.vue?vue&type=script&lang=js"
export * from "./IntAstaSxPreview.vue?vue&type=script&lang=js"
import style0 from "./IntAstaSxPreview.vue?vue&type=style&index=0&id=a415ad26&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports